import React from 'react';
import { HelpCenterIcon, ProfileSwitcherIcon } from '@pushpay/iconography';
import { Link } from '@pushpay/link';
import { HeaderTemplate, HeaderTemplateOld, OrgSwitcher, OrgSwitcherOld, ProductSwitcher, ProfileDropdown, ProfileMenu, ProfilePanel } from '@pushpay/shell';
import { clsx } from '@pushpay/styles';
import { useMediaBreakpoint } from '@pushpay/theming';
import DownloadsPanel from '../downloads-panel/downloads-panel';
import { Divider } from './divider';
import useStyles from './use-styles';

const Header = function Header(props) {
  const {
    classes: classesProp,
    className: classNameProp,
    'data-pp-at-target': targetId,
    helpUrl,
    helpLabel,
    avatarID,
    firstName = '',
    lastName = '',
    avatarImgUrl,
    emailAddress,
    profileButtonAriaLabel,
    profileLabel,
    logoutLabel,
    loggingOutLabel,
    profileLink,
    profilePath,
    logout,
    organizations,
    currentOrganization,
    isSpa,
    personalAccountLabel,
    personalAccount,
    downloadsPanelConfig,
    productSwitcherConfig,
    selectOrganizationLabel,
    onOrgItemSelected,
    isLoadingOrg,
    deprecated,
    clearButtonAriaLabel,
    placeholder,
    buttonLabel,
    ...rest
  } = props;
  const profileLinkProps = {
    profileLink,
    profilePath
  };
  const isTabletAndBelow = useMediaBreakpoint('TABLET_AND_BELOW');
  const classes = useStyles(classesProp);

  const leftSection = () => {
    if (deprecated) {
      return productSwitcherConfig && /*#__PURE__*/React.createElement(ProductSwitcher, Object.assign({
        isMobile: isTabletAndBelow
      }, productSwitcherConfig, {
        "data-pp-at-target": `${targetId}-product-switcher`
      }));
    }

    return productSwitcherConfig && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProductSwitcher, Object.assign({
      isMobile: isTabletAndBelow,
      currentProductDisplayStyle: "icon"
    }, productSwitcherConfig, {
      "data-pp-at-target": `${targetId}-product-switcher`
    })), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(OrgSwitcher, {
      "data-pp-at-target": `${targetId}-OrgSwitcher`,
      organizations: organizations,
      currentOrgKey: currentOrganization.key,
      selectOrganizationLabel: selectOrganizationLabel,
      onItemSelected: onOrgItemSelected,
      isLoadingOrg: isLoadingOrg,
      buttonLabel: buttonLabel,
      placeholder: placeholder,
      clearButtonAriaLabel: clearButtonAriaLabel
    })));
  };

  const toolBar = /*#__PURE__*/React.createElement(React.Fragment, null, !!downloadsPanelConfig && !isTabletAndBelow && /*#__PURE__*/React.createElement(DownloadsPanel, Object.assign({
    className: classes.links,
    classes: {
      button: classes.linkAction
    }
  }, downloadsPanelConfig, {
    "data-pp-at-target": `${targetId}-downloads-panel`
  })), /*#__PURE__*/React.createElement("a", {
    "aria-label": helpLabel,
    title: helpLabel,
    className: clsx(classes.links, classes.helpCenterLink, classes.linkAction),
    href: helpUrl,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(HelpCenterIcon, {
    "data-pp-at-target": `${targetId}-HelpCenter`,
    className: classes.helpCenter
  })), deprecated && !isTabletAndBelow && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    classes: {
      root: classes.divider
    }
  }), /*#__PURE__*/React.createElement(OrgSwitcherOld, {
    "data-pp-at-target": `${targetId}-OrgSwitcher`,
    organizations: organizations,
    currentOrganization: currentOrganization,
    selectOrganizationLabel: selectOrganizationLabel,
    isMobile: isTabletAndBelow
  })));
  const commonProfileProps = {
    profileId: avatarID,
    firstName,
    lastName,
    profileImgUrl: avatarImgUrl
  };
  const profileTargetId = `${targetId}-avatarDetails`;
  const panels = [/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProfilePanel, Object.assign({
    "data-pp-at-target": profileTargetId,
    emailAddress: emailAddress,
    profileLabel: profileLabel,
    deprecated: deprecated
  }, profileLinkProps, commonProfileProps)), /*#__PURE__*/React.createElement(ProfileMenu, {
    "data-pp-at-target": profileTargetId,
    logoutLabel: logoutLabel,
    loggingOutLabel: loggingOutLabel,
    menuItems: [{
      component: Link,
      leftElement: /*#__PURE__*/React.createElement(ProfileSwitcherIcon, {
        className: classes.personalAccountIcon
      }),
      label: personalAccountLabel,
      itemValue: 'personal',
      href: personalAccount,
      target: '_blank'
    }],
    onLogout: logout,
    deprecated: deprecated
  }))];
  const rightSection = /*#__PURE__*/React.createElement(ProfileDropdown, Object.assign({
    alignment: "right",
    "data-pp-at-target": profileTargetId,
    isMobile: isTabletAndBelow,
    panels: panels,
    profileButtonAriaLabel: profileButtonAriaLabel,
    deprecated: deprecated
  }, commonProfileProps));

  if (deprecated) {
    return /*#__PURE__*/React.createElement(HeaderTemplateOld, Object.assign({}, rest, {
      leftSection: leftSection(),
      toolBar: toolBar,
      rightSection: rightSection,
      "data-pp-at-target": "CAP-layout-header"
    }));
  }

  return /*#__PURE__*/React.createElement(HeaderTemplate, Object.assign({
    classes: {
      leftSide: clsx(isTabletAndBelow && classes.leftSectionMobile)
    }
  }, rest, {
    leftSection: leftSection(),
    toolBar: toolBar,
    rightSection: rightSection,
    "data-pp-at-target": "CAP-layout-header"
  }));
};

export default Header;